import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { ReclamacaoService } from 'src/app/service/reclamacao/reclamacao.service';
import { DesmarcarOutrasOpcoesService } from 'src/app/service/util/desmarcar-outras-opcoes.service';
import { ERRO_CONSULTAR_PROCESSO, MSG_OBG_NUM_PROCESSO, MSG_OBG_TIPO_JUSTICA } from './../../../../tools/Mensagens';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { FILE_UPLOADER } from 'src/app/componentes/file-uploader/file-uploader.component';

@Component({
  selector: "app-processo",
  templateUrl: "./processo.component.html",
  styleUrls: ["./processo.component.css"]
})
export class ProcessoComponent implements OnInit {

  @Input() visualizacao: boolean;
  @Input() edicao: boolean;
  checkedMarcado: boolean = false;
  checkedPrimeiraInstancia: boolean = false;
  listaClassificacaoComponente = [];
  listaTipoProcessoComponente = [];
  charNum = 5000;
  isNotNumber = false;
  isNotValidNumeroProcesso = false;
  tipoDeJusticaPrimeiraVaraOpcao: any;
  @ViewChild(FILE_UPLOADER, { static: false }) fileUploaderProcesso;
  codUnidadeProcesso = 0;
  siglaUnidadeProcesso = "";
  classificacaoNenhumaOpcaoAnteriorId = 30;
  arquivosSalvos: any[];

  constructor(
    public service: ReclamacaoService,
    public desmarcarOutrasOpcoesService: DesmarcarOutrasOpcoesService,
    public authService: AuthService) {
  }

  ngOnInit() {
    this.preencherListaClassificacao();
    this.preencherListaTipoProcesso();

    if (!this.visualizacao && !this.edicao) {

      this.service.reclamacao.controls.descricaoReclamacao.setValue('');
      this.service.reclamacao.controls.numeroProcesso.setValue(null);
      this.service.reclamacao.controls.comarca.setValue(null);
      this.service.reclamacao.controls.vara.setValue(null);
      this.service.reclamacao.controls.numeroINFOPEN.setValue(null);
      this.service.reclamacao.controls.tipoDeJustica.setValue('');

      this.service.reclamacao.controls.opcaoTipoDeJustica.setValue('');
      this.service.reclamacao.controls.codUnidade.setValue(null);
      this.service.reclamacao.controls.siglaUnidade.setValue('');

    }else{
      this.tratarVisualizacaoOuEdicao();
    }
  }

  tratarVisualizacaoOuEdicao() {

    if(this.service.reclamacao.controls != null){

      // Tratamento para o Tipo de Justiça e Opção do Tipo de Justiça
      if(this.service.reclamacao.get("tipoDeJustica").value != null){

        if(this.service.reclamacao.get("tipoDeJustica").value === "1"){
          this.checkedPrimeiraInstancia = true;

          // Se o tipo de justiça for 2 - Reclamação de cunho disciplinar, deverá ser liberado o componente.
          if(this.service.reclamacao.get("opcaoTipoDeJustica").value === "2"){
            this.tipoDeJusticaPrimeiraVaraOpcao = 2;
            this.arquivosSalvos = this.service.reclamacao.controls.filesCunhoDisciplinar != null ?
                                    this.service.reclamacao.controls.filesCunhoDisciplinar.value : [];
          }else{
            this.tipoDeJusticaPrimeiraVaraOpcao = 1;
          }

        }else{
          this.checkedPrimeiraInstancia = false;
        }
      }
    }
  }

  changeTipoJustica(status: boolean) {
    this.service.reclamacao.controls.numeroProcesso.enable();
    this.service.reclamacao.controls.numeroProcesso.setValue('');
    this.checkedPrimeiraInstancia = status;
    this.service.reclamacao.controls.opcaoTipoDeJustica.setValue(null);
    this.service.reclamacao.controls.vara.setValue('');
    this.service.reclamacao.controls.comarca.setValue('');
    this.service.reclamacao.controls.codUnidade.setValue(null);
    this.service.reclamacao.controls.siglaUnidade.setValue('');

  }
  changeTipoJusticaPrimeiraVaraOpcao(item: any) {
    this.tipoDeJusticaPrimeiraVaraOpcao = item+'';
    this.service.reclamacao.controls.opcaoTipoDeJustica.setValue(this.tipoDeJusticaPrimeiraVaraOpcao);
  }

  preencherListaClassificacao() {

    // Obtendo a classificação Nenhuma das opções anteriores, para ser inserido por ultimo na listagem
    //TODO Deverá se verificado uma forma de transformar a classificação Nenhuma das opções anteriores como
    // o ultimo item de qualquer busca por classificação.
    //Ocorrendo problema ao montar a lista, a mesma é reordenada e perde modificação feita no backend.
    var ultimoItemClassificacao = this.service.reclamacao.value.listaClassificacaoCompleta
        .find(item => item.id === this.classificacaoNenhumaOpcaoAnteriorId);

    this.listaClassificacaoComponente = this.service.reclamacao.value.listaClassificacaoCompleta
      .filter(item => item.assunto.id === this.service.reclamacao.value.assunto.id && item.id !== this.classificacaoNenhumaOpcaoAnteriorId);

      this.listaClassificacaoComponente.push(ultimoItemClassificacao);
      //console.log('Lista Processo Judicial -> ', this.listaClassificacaoComponente);
  }

  preencherListaTipoProcesso() {
    this.listaTipoProcessoComponente = this.service.reclamacao.value.listaTipoProcessoCompleta;
  }

  checkClassificacao(item) {
    this.desmarcarOutrasOpcoesService.desmarcarTodasOpcoesExcetoItem(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao();
  }

  checkTipoProcesso() {
    this.service.reclamacao.controls.listaTipoProcesso.setValue(this.listaTipoProcessoComponente.filter(ltp => ltp.selecionado));
  }

  atribuirListaClassificacao() {
    this.service.reclamacao.controls.listaClassificacao.setValue(this.listaClassificacaoComponente.filter(lcc => lcc.selecionado));
  }

  contemErro(str) {
    return this.service.reclamacao.controls[str].touched &&
      this.service.reclamacao.controls[str].errors != null;
  }

  countChar(valor, max) {
    this.charNum = max - valor.length;
  }

  maskNumeroProcesso(numeroProcesso) {

    numeroProcesso = numeroProcesso.trim().replace(/\./g, '').replace(/-/g, '');

    if (numeroProcesso.length >= 13 && numeroProcesso.charAt(13) !== '8') {

      this.isNotValidNumeroProcesso = true;

      return;

    } else if (numeroProcesso.length >= 14 && numeroProcesso.charAt(14) !== '1') {

      this.isNotValidNumeroProcesso = true;

      return;

    } else if (numeroProcesso.length >= 15 && numeroProcesso.charAt(15) !== '3') {

      this.isNotValidNumeroProcesso = true;

      return;

    }

    this.isNotValidNumeroProcesso = numeroProcesso.length > 20;

    if (numeroProcesso && numeroProcesso.length >= 20 && numeroProcesso.length < 25) {

      let value = numeroProcesso;
      let resultado: any;
      value = value.toString();
      value = value.replace('-', '');
      value = value.replace('.', '');

      resultado = value.split('');
      resultado.splice(7, 0, '-');
      resultado.splice(10, 0, '.');
      resultado.splice(15, 0, '.');
      resultado.splice(17, 0, '.');
      resultado.splice(20, 0, '.');
      value = resultado.join('');

      this.service.reclamacao.controls.numeroProcesso.setValue(value);

    }

  }

  validaNumeroProcesso() {

    const regra = /^[0-9]*$/;
    const numero = this.service.reclamacao.value.numeroProcesso.trim().replace(/\./g, '').replace(/-/g, '');

    if (this.service.reclamacao.value.numeroProcesso && numero !== '') {

      if (numero.match(regra)) {

        this.isNotNumber = false;

      } else {

        this.isNotNumber = true;
        this.service.reclamacao.controls.numeroProcesso.setValue(numero.substring(0, numero.length - 1));

      }

    }

  }

  isChecked(valor) {
    if (valor.descricao === 'Execução Penal') {
      if (valor.selecionado) {
        this.checkedMarcado = true;
      } else {
        this.listaTipoProcessoComponente.filter(lc => lc).map(lc => lc.selecionado = false);
        this.checkedMarcado = false;
      }
    }

    if (valor.descricao === 'Nenhuma das opções anteriores') {
      if (valor.selecionado) {
        this.checkedMarcado = false;
        this.listaTipoProcessoComponente.filter(lc => lc).map(lc => lc.selecionado = false);
      }
    }
  }

  buscarProcesso() {

    if (!this.isNotValidNumeroProcesso) {

      if (this.service.reclamacao.value.tipoDeJustica === '' || this.service.reclamacao.value.tipoDeJustica == null) {

        alert(MSG_OBG_TIPO_JUSTICA);

      } else if (this.service.reclamacao.value.numeroProcesso === '' || this.service.reclamacao.value.numeroProcesso == null) {

        alert(MSG_OBG_NUM_PROCESSO);

      } else {

        this.service.buscarProcesso().subscribe(retorno => {

          if (retorno) {

            this.service.reclamacao.controls.comarca.setValue(retorno.comarca);
            this.service.reclamacao.controls.vara.setValue(retorno.vara);
            //Atribuindo valores da unidade de direção do foro, necessário para o encaminhamento correto para o SEI. (OS 860)
            this.service.reclamacao.controls.codUnidade.setValue(retorno.unidadeDirecaoForo.id);
            this.service.reclamacao.controls.siglaUnidade.setValue(retorno.unidadeDirecaoForo.sigla);

          } else {

            alert(ERRO_CONSULTAR_PROCESSO);

          }

        }, () => alert(ERRO_CONSULTAR_PROCESSO));

      }

    }

  }

get arquivosAnexados(){
  return this.fileUploaderProcesso;
}

}
